import Image from "next/image"

export type BrandMarkProps = {
  /** Navbar: compact mark; footer: slightly larger for the brand column. */
  variant?: "nav" | "footer"
}

export function BrandMark({ variant = "nav" }: BrandMarkProps) {
  const size = variant === "footer" ? 44 : 32
  return (
    <span className={`brand-mark-emblem brand-mark-emblem--${variant}`}>
      <Image
        src="/rivyu-logo-emblem.png"
        alt=""
        width={512}
        height={512}
        priority={variant === "nav"}
        sizes={`${size}px`}
        style={{ width: size, height: size, display: "block", objectFit: "contain" }}
      />
    </span>
  )
}
